'use strict';

function getClientId(value = '') {
  return value
    ? value
        .split('.')
        .slice(-2)
        .join('.')
    : '';
}

function getSource(source, isTouch) {
  if (source) {
    return source;
  }

  if (isTouch) {
    return 'touch';
  }

  return 'web';
}

function isClickFromDirectLink(widgets) {
  if (
    Array.isArray(widgets) &&
    widgets.length &&
    widgets[0].type === 'direct-link'
  ) {
    return true;
  }

  return false;
}

function updateDirectLink(widgets, eventId) {
  const { element } = widgets[0];
  if (element.href) {
    const url = new URL(element.href);
    url.searchParams.set('eventId', eventId);

    element.setAttribute('href', url.href);
  }
}

module.exports = {
  getClientId,
  getSource,
  isClickFromDirectLink,
  updateDirectLink,
};
